import React from 'react';

const documentTypeOptions = [
  { value: 'EIN', label: 'Employer Identification Number (EIN)' },
  { value: 'UEI', label: 'Unique Entity Identifier (UEI)' },
  { value: 'SBA', label: 'Small Business Administration' },
  { value: 'SBC', label: 'SBC.gov SBC Registration' },
  { value: 'COF', label: 'Certificate of Formation' },
  { value: 'OTH', label: 'Other' },
];

const DropdownList = ({ value, onChange, label }) => {
  return (
    <div>
      {label && <label>{label}</label>}
      <select value={value} onChange={onChange}>
        <option value="">Select an option</option>
        {documentTypeOptions.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default DropdownList;